<section class="word-detail" role="region" [attr.aria-labelledby]="headingId">
  <header class="word-detail__header">
    <h5 class="word-detail__title" [id]="headingId">
      {{ 'QUESTIONS.PRONUNCIATION.WORD_DETAIL.TITLE' | translate: { word: detail().text } }}
    </h5>
    <odl-button
      variant="text"
      size="small"
      class="word-detail__close"
      [id]="closeId"
      [description]="'QUESTIONS.PRONUNCIATION.WORD_DETAIL.CLOSE' | translate"
      (click)="dismiss.emit()"
    >
      <odl-icon name="close" slot="only-icon"></odl-icon>
    </odl-button>
    <odl-tooltip placement="top" [attr.for]="'#' + closeId">{{
      'QUESTIONS.PRONUNCIATION.WORD_DETAIL.CLOSE' | translate
    }}</odl-tooltip>
  </header>

  @if (detail().accuracy !== null) {
    <p class="word-detail__score" [ngClass]="detail().style">
      {{ detail().accuracy | number: '1.0-0' }}/100
      @if (detail().resultLabel; as resultLabel) {
        <span class="word-detail__result">· {{ resultLabel | translate }}</span>
      }
    </p>
  }

  @if (detail().omitted) {
    <p class="word-detail__message">
      {{ 'QUESTIONS.PRONUNCIATION.WORD_DETAIL.NOT_DETECTED' | translate }}
    </p>
  }

  @if (detail().syllables.length) {
    <ul
      class="word-detail__parts"
      [attr.aria-label]="'QUESTIONS.PRONUNCIATION.WORD_DETAIL.SYLLABLES' | translate"
    >
      @for (part of detail().syllables; track $index) {
        <li
          class="word-detail__part"
          [ngClass]="part.style"
          [attr.aria-label]="
            'QUESTIONS.PRONUNCIATION.WORD_DETAIL.PART'
              | translate
                : {
                    part: part.text,
                    score: part.accuracy ?? '-',
                    result: part.resultLabel ? (part.resultLabel | translate) : '',
                  }
          "
        >
          <span aria-hidden="true">{{ part.text }}</span>
        </li>
      }
    </ul>
  }

  @if (detail().transcription; as transcription) {
    <p class="word-detail__transcription">
      <span class="word-detail__transcription-label">
        {{ 'QUESTIONS.PRONUNCIATION.WORD_DETAIL.IPA' | translate }}
      </span>
      <span class="word-detail__transcription-value">{{ transcription }}</span>
    </p>
  }

  <odl-button
    variant="secondary"
    size="small"
    class="word-detail__listen"
    [class.playing]="playing()"
    (click)="listen.emit()"
  >
    <odl-icon name="play" slot="start"></odl-icon>
    {{ 'QUESTIONS.PRONUNCIATION.WORD_DETAIL.LISTEN' | translate }}
  </odl-button>
</section>
